import { connect } from 'react-redux';
import ByTicket from './ByTicket';
import { getTickets, selectTicket } from '../../actions/ticket';

const mapStateToProps = state => ({
  tickets: state.ticket.tickets,
  ticketsLoading: state.ticket.ticketsLoading,
  ticketsLoaded: state.ticket.ticketsLoaded,
  selectedTicketCode: state.ticket.selectedTicketCode,
  units: state.units,
  resources: state.resources,
  groups: state.groups
});
const mapDispatchToProps = dispatch => ({
  getTickets: dispatch(getTickets),
  selectTicket: dispatch(selectTicket)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ByTicket);



// WEBPACK FOOTER //
// ./src/containers/ByTicket/index.js